module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e2559f595c0c3b13891fe2567931dca7.png";